import { TextField } from '@mui/material';

const TextInput = (props) => {
  return (
    <TextField {...props} />
  );
};

export default TextInput;